// 水控
import Log from "../view/log";
import WaterManagementNav from "../view/WaterManage/WaterManagementNav";
import WaterControllerManagement from "../view/WaterManage/ControllerManagement/ControllerManagement";
import WaterControllerAdd from "../view/WaterManage/ControllerManagement/ControllerAdd";
import WaterControllerCurrent from "../view/WaterManage/ControllerManagement/ControllerCurrent";
import WaterControllerModify from "../view/WaterManage/ControllerManagement/ControllerModify";
import WaterControllerDeviceStatusLog from "../view/WaterManage/ControllerDeviceStatusLog/ControllerDeviceStatusLog";
import WaterAmmeterManagement from "../view/WaterManage/AmmeterManagement/AmmeterManagement";
import WaterAmmeterAdd from "../view/WaterManage/AmmeterManagement/AmmeterAdd";
import WaterAmmeterCurrent from "../view/WaterManage/AmmeterManagement/AmmeterCurrent";
import WaterAmmeterModify from "../view/WaterManage/AmmeterManagement/AmmeterModify";
import WaterDeviceSceneConfig from "../view/WaterManage/DeviceSceneConfig/DeviceSceneConfig";
import WaterConfigCenter from "../view/WaterManage/WaterConfig/WaterConfigCenter";
import WaterConfigModify from "../view/WaterManage/WaterConfig/WaterConfigModify";
import WaterAccountCenter from "../view/WaterManage/WaterAccountConfig/WaterAccountCenter";
import WaterAccountModify from "../view/WaterManage/WaterAccountConfig/WaterAccountModify";
import WaterPayRecord from "../view/WaterManage/WaterPayRecord/WaterPayRecord";
import WaterRentMoney from "../view/WaterManage/WaterRentMoney/WaterRentMoney";
import WaterQuantity from "../view/WaterManage/WaterQuantity/WaterQuantity";
import WaterQuantityPublic from "../view/WaterManage/WaterQuantityPublic/WaterQuantityPublic";
import WaterQuantityRoom from "../view/WaterManage/WaterQuantityRoom/WaterQuantityRoom";
import WaterOverView from "../view/WaterManage/OverView/OverView";
import WatersettlementRecord from "../view/WaterManage/settlementRecord/settlementRecord";
import WaterLog from "../view/WaterManage/WaterLog/WaterLog";
import WaterConfigSettle from "../view/WaterManage/WaterConfigSettle/WaterConfigSettle";
import WaterMonitoring from "../view/WaterManage/WaterMonitoring/WaterMonitoring";

export default [
  /* 水控 */
  {
    path: "/water_controller_management",
    name: "water-controller-management",
    components: {
      default: WaterManagementNav,
      a: WaterControllerManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_controller_add",
    name: "water-controller-add",
    components: {
      default: WaterManagementNav,
      a: WaterControllerAdd
    }
  },
  {
    path: "/water_controller_modify/:id",
    name: "water-controller-modify",
    components: {
      default: WaterManagementNav,
      a: WaterControllerModify
    }
  },
  {
    path: "/water_controller_device_status_log",
    name: "water-controller-device-status-log",
    components: {
      default: WaterManagementNav,
      a: WaterControllerDeviceStatusLog
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_controller_current/:id",
    name: "water-controller-current",
    components: {
      default: WaterManagementNav,
      a: WaterControllerCurrent
    }
  },
  {
    path: "/water_ammeter_management",
    name: "water-ammeter-management",
    components: {
      default: WaterManagementNav,
      a: WaterAmmeterManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_ammeter_add",
    name: "water-ammeter-add",
    components: {
      default: WaterManagementNav,
      a: WaterAmmeterAdd
    }
  },
  {
    path: "/water_ammeter_current/:id",
    name: "water-ammeter-current",
    components: {
      default: WaterManagementNav,
      a: WaterAmmeterCurrent
    }
  },
  {
    path: "/water_ammeter_modify/:id",
    name: "water-ammeter-modify",
    components: {
      default: WaterManagementNav,
      a: WaterAmmeterModify
    }
  },
  {
    path: "/water_device_scene_config",
    name: "water-device-scene-config",
    components: {
      default: WaterManagementNav,
      a: WaterDeviceSceneConfig
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_config_center",
    name: "water-config-center",
    components: {
      default: WaterManagementNav,
      a: WaterConfigCenter
    }
  },
  {
    path: "/water_config_modify",
    name: "water-config-modify",
    components: {
      default: WaterManagementNav,
      a: WaterConfigModify
    }
  },
  {
    path: "/electronic_account_center",
    name: "water-account-center",
    components: {
      default: WaterManagementNav,
      a: WaterAccountCenter
    }
  },
  {
    path: "/water_config_settle",
    name: "water-config-settle",
    components: {
      default: WaterManagementNav,
      a: WaterConfigSettle
    }
  },
  {
    path: "/water_account_modify",
    name: "water-account-modify",
    components: {
      default: WaterManagementNav,
      a: WaterAccountModify
    }
  },
  {
    path: "/water_pay_record",
    name: "water-pay-record",
    components: {
      default: WaterManagementNav,
      a: WaterPayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_settlement_record",
    name: "water-settlement-record",
    components: {
      default: WaterManagementNav,
      a: WatersettlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_rent_money",
    name: "water-rent-money",
    components: {
      default: WaterManagementNav,
      a: WaterRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_quantity",
    name: "water-quantity",
    components: {
      default: WaterManagementNav,
      a: WaterQuantity
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_quantity_public",
    name: "water-quantity-public",
    components: {
      default: WaterManagementNav,
      a: WaterQuantityPublic
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_quantity_room",
    name: "water-quantity-room",
    components: {
      default: WaterManagementNav,
      a: WaterQuantityRoom
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_monitoring",
    name: "water-monitoring",
    components: {
      default: WaterManagementNav,
      a: WaterMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/water_log",
    name: "water-log",
    components: {
      default: WaterManagementNav,
      a: WaterLog
    }
  },
  {
    path: "/water/over_view",
    name: "water-over-view",
    components: {
      default: WaterManagementNav,
      a: WaterOverView
    }
  },
  /* 水控 */

  // 智慧用水操作日志
  {
    path: "/water_control_log",
    name: "water-control-log",
    components: {
      default: WaterManagementNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/WaterManage.js